export const mixpanelSigninEventLocation = (
  page: 'checkout' | 'sign_in' | 'account_pop_up' | undefined,
) => {
  switch (page) {
    case 'sign_in': {
      return 'account_login'
    }
    case 'account_pop_up': {
      return 'nav_bar_popup'
    }
    case 'checkout': {
      return 'checkout'
    }
    default: {
      return ''
    }
  }
}
